import { render } from "./AppHeaderDropdownTasks.vue?vue&type=template&id=343891bb"
import script from "./AppHeaderDropdownTasks.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownTasks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/HCL_coreui_vue_Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__